export function getCurrentTimestamp() {
  return Math.round(new Date().getTime() / 1000);
}
